import { todayIsoDateLocal } from '../../../utils/caseFieldValidation';

export function isHighUrgencyLevel(name: string): boolean {
  return name.trim().toLowerCase().includes('high');
}

export function minDeadlineDateForNomination(): string {
  return todayIsoDateLocal();
}
